'use client'

import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { formatCurrency } from '@okra/shared'
import Link from 'next/link'

interface OverdueSummary {
  totalCount: number
  totalAmount: number
  byClient: { clientId: string; clientName: string; count: number; totalAmount: number }[]
}

export function OverdueSummaryBanner() {
  const { data } = useQuery<OverdueSummary>({
    queryKey: ['credit-alerts-summary'],
    queryFn: () => api.get('/credit-alerts/summary'),
  })

  if (!data || data.totalCount === 0) return null

  return (
    <div className="rounded-lg border border-destructive/50 bg-destructive/5 px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <span className="text-destructive font-semibold text-sm">
          ⚠ {data.totalCount} impayé{data.totalCount > 1 ? 's' : ''} en retard
        </span>
        <span className="text-sm text-muted-foreground">
          Total : {formatCurrency(data.totalAmount)}
        </span>
        {data.byClient.slice(0, 2).map((c) => (
          <span key={c.clientId} className="text-xs text-muted-foreground hidden sm:inline">
            {c.clientName} ({formatCurrency(c.totalAmount)})
          </span>
        ))}
      </div>
      <Link href="/credit/overdue" className="text-sm text-primary hover:underline shrink-0">
        Voir tout →
      </Link>
    </div>
  )
}
